export default __webpack_public_path__ + "static/media/SL_image.d487789e.png";